export enum ERegistrationType {
  Contact = 0,
  Customer = 1,
  Helpdesk = 2,
  Supplier = 3,
  User = 4,
  Visitor = 5,
}

export enum EPersonType {
  Person = 1, // fisica
  Company = 2, // juridica
}

export enum EPersonPhoneType {
  Home = 1,
  Mobile = 2,
  Commerce = 3,
  Other = 4,
  /** The mobile starred in the panel: the one the profile shows and notifications go to. */
  MobileNotification = 5,
}
